/**
 * 事件监听处理
 * @Author: moonye
 * @Date: 2019-08-29 11:15:58
 * @Last Modified by: moonye
 * @Last Modified time: 2019-08-29 13:45:42
 */
import util from './util';

/**
 * 拦截点击请求，并获取跟点击元素相关的 module 和 position
 */
function injectHref() {
  document.removeEventListener('click', clickHandler);
  document.addEventListener('click', clickHandler);
}

const listeners = [];
function clickHandler(e) {
  const targetDom = e.target;
  const aTarget = util.closest(targetDom, 'a');
  const linkTarget = util.closest(targetDom, '.js-report-link');

  if (!aTarget && !linkTarget) {
    return;
  }

  const finalTarget = aTarget || linkTarget;

  listeners.forEach((listener) => {
    listener.apply(null, [finalTarget, e]);
  })
}

function addListener(listener) {
  if (util.isFunction(listener)) {
    listeners.push(listener);
  }
}

function removeListener(listener) {
  if (util.isFunction(listener)) {
    listeners.forEach((l, i) => {
      if (l === listener) {
        listeners.splice(i, 1);
      }
    });
  }
}
export default {
  injectHref,
  addListener,
  removeListener
}